import React from "react";
import { Link } from "react-router-dom";
import SocialLinks from "@/components/SocialLinks";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-white border-t border-[color:var(--line)] text-neutral-700">
      <div className="container-x py-16 grid md:grid-cols-4 gap-10">
        <div>
          <img src="/logo-maxine.png" alt="Maxine Consulting OPC Private Limited" className="h-10 w-auto" />
          <p className="mt-4 text-sm leading-relaxed text-neutral-600">
            Product, web, cloud and marketing under one roof. Dubai · Bengaluru · Frankfurt · London.
          </p>
          <div className="mt-6">
            <div className="font-mono text-[10px] uppercase tracking-widest text-[color:var(--brand)] mb-3">Follow</div>
            <SocialLinks tone="dark" />
          </div>
        </div>
        {[
          { t: "Services", l: [["Software Products", "#products"], ["Web Development", "#web"], ["Cloud & Hosting", "#cloud"], ["Digital Marketing", "#marketing"]] },
          { t: "Company", l: [["Case Studies", "#cases"], ["Insights", "/blog"], ["Partners", "/partners"], ["Careers", "#careers"], ["Global reach", "#reach"]] },
          { t: "Contact", l: [["support@maxineconsulting.in", "mailto:support@maxineconsulting.in"], ["support@maxinesolutions.com", "mailto:support@maxinesolutions.com"], ["sales@maxinesolutions.com", "mailto:sales@maxinesolutions.com"], ["WhatsApp · +91 70549 86771", "https://wa.me/7054986771"]] },
        ].map((col) => (
          <div key={col.t}>
            <div className="font-mono text-[10px] uppercase tracking-widest text-[color:var(--brand)]">{col.t}</div>
            <ul className="mt-4 space-y-2">
              {col.l.map(([label, href]) => (
                <li key={label}>
                  <a href={href} className="text-sm hover:text-[color:var(--brand)] transition-colors">{label}</a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-[color:var(--line)]">
        <div className="container-x py-6 flex flex-wrap items-center justify-between gap-4 text-xs text-neutral-500">
          <span>© {new Date().getFullYear()} Maxine Consulting OPC Private Limited. All rights reserved.</span>
          <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-[color:var(--brand)] transition-colors">Admin login →</Link>
        </div>
      </div>
    </footer>
  );
}
